import { LinearProgress, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CollaborationStepContainer } from 'features/collaboration-base/components';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface TeamDeclinedProps {
  userNumber: string;
  userName: string;
  onCancel: () => void;
}

export const TeamDeclined: FC<TeamDeclinedProps> = ({
  userNumber,
  userName,
  onCancel,
}) => {
  const { t: ct } = useTranslation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'teamDeclined',
  });

  return (
    <CollaborationStepContainer testId='team-declined'>
      {/* TODO: update text styles when Doug finish it in Figma */}
      <Typography variant='body1' color={theme.palette.grey[50]}>
        {t('userIsNoLongerAvailable', { userName, userNumber })}
      </Typography>
      <StyledLinearProgress />
      <Typography variant='body2' color={theme.palette.common.white} mt={8}>
        {ct('searchingNextInterpreter')}
      </Typography>
      <CancelButton
        fullWidth
        size='small'
        color='secondary'
        title={ct('cancel')}
        onClick={onCancel}
        autoFocus
      >
        {ct('cancel')}
      </CancelButton>
    </CollaborationStepContainer>
  );
};

const StyledLinearProgress = styled(LinearProgress)`
  margin-top: ${theme.spacing(8)};
`;

const CancelButton = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;
